<template>
  <nav-bar title="用户钢瓶" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <customer-info v-if="!userId"/>
    <div class="customer-info" v-else>
      <span>{{companyInfo.companyName}}</span>
      <span>{{companyInfo.userName}}</span>
    </div>

    <van-cell-group class="group" title="钢瓶">
      <van-cell
        v-for="item in nowList"
        :key="item.goodsId"
        :title="`现有${item.goodsName}`"
        :value="`${item.goodsCount}瓶`"
        :to="userId ? `/cylinderListByIdAndType/${userId}/${item.goodsId}` : '/cylinderList'"
        is-link
      />
      <van-cell
        v-for="item in hisList"
        :key="item.goodId"
        :title="`累计${item.goodsName}`"
        :value="`${item.goodsCount}瓶`"
      />
    </van-cell-group>
    <div class="title van-hairline--bottom">返瓶记录</div>
    <order-list-item :list="list" @detail="handleDetailClick" />
    <Empty v-if="!loading && !list.length" description="暂无记录" />
  </Content>
</template>

<script>
import { ref, reactive, toRefs, computed } from 'vue'
import { getCustomerMesslist, getUserReturnOrderList } from '@/api/order'
import { bGlmCustomer } from '@/api/user'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetDataLoading as useGetLoading, useGetData } from '@/hooks/useGetData'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'CustomerCylinder', // 用户钢瓶
  props: ['userId'],
  setup(props) {
    const store = useStore()
    const userId = computed(() => store.state.customer.userId)
    // 钢瓶信息
    const cylinderInfo = reactive({
      hisList: [],
      nowList: []
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getCustomerMesslist,
      data => {
        for (const key in data) {
          cylinderInfo[key] = data[key]
        }
      },
      props.userId || userId.value
    )
    getDataLoading()
    const companyInfo = ref('')
    const getCompanyInfo = useGetData(bGlmCustomer, data => {
      companyInfo.value = data
    })
    if (props.userId) {
      getCompanyInfo(props.userId)
    }

    // 返瓶记录
    const list = ref([])
    const { getData, loading } = useGetLoading(getUserReturnOrderList, data => {
      list.value = data.rows
    })
    getData({ userId: props.userId || userId.value })

    const router = useRouter()
    const handleDetailClick = ({ id }) => {
      router.push(`/bottleReturnRecordDetail/${id}`)
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      ...toRefs(cylinderInfo),
      list,
      loading,
      handleDetailClick,
      companyInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  font-size: 14px;
  color: #666;
}
.customer-info {
  display: flex;
  padding: 16px;
  font-size: 14px;
  color: #333;
  font-weight: 600;
  justify-content: space-between;
  background-color: #fff;
}
</style>
